;(function() {
  'use strict'

  Service.$inject = ["glUtils"];
  angular.module('app.core').service('projectMatchService', Service)

  var TYPE_LABEL = {
    surveyTitle: 'Survey',
    surveyReference: 'Reference',
    questionTitle: 'Question',
  }

  // Splits the query as the search endpoint does: any run of characters that
  // is not a letter or digit. A constructor, as ESLint here rejects the u flag.
  var TERM_SEPARATOR = new RegExp('[^\\p{L}\\p{N}]+', 'u')

  /* @ngInject */
  function Service(glUtils) {
    var self = this

    self.build = build

    function build(hit, query, name) {
      var nameMatch = _.find(hit.matches, { type: 'projectName' })
      var titleMatch = _.find(hit.matches, function(match) {
        return match.type !== 'projectName'
      })
      var shown = (titleMatch ? 1 : 0) + (nameMatch ? 1 : 0)
      var more = Math.max((hit.totalMatchCount || 0) - shown, 0)
      var tokens = titleMatch ? tokenise(titleMatch.title, query) : []
      var moreLabel = more
        ? more + ' more ' + glUtils.numberSwitch(more, 'match', 'matches')
        : null
      return {
        nameTokens: nameMatch ? tokenise(name, query) : null,
        label: (titleMatch && TYPE_LABEL[titleMatch.type]) || null,
        tokens: tokens,
        moreLabel: moreLabel,
        hasEvidence: !!(tokens.length || moreLabel),
      }
    }

    function tokenise(text, query) {
      var source = text || ''
      var terms = splitTerms(query)
      if (!terms.length) return [{ text: source, isMatch: false }]

      var ranges = findRanges(source, terms)
      if (!ranges.length) return [{ text: source, isMatch: false }]

      return buildTokens(source, ranges)
    }

    function splitTerms(query) {
      var terms = _.compact((query || '').split(TERM_SEPARATOR))
      return _.orderBy(terms, 'length', 'desc')
    }

    function findRanges(source, terms) {
      var pattern = new RegExp(
        '\\b(?:' + _.map(terms, _.escapeRegExp).join('|') + ')',
        'gi'
      )
      var ranges = []
      var match
      while ((match = pattern.exec(source)) !== null) {
        ranges.push({ start: match.index, end: match.index + match[0].length })
        if (match.index === pattern.lastIndex) pattern.lastIndex++
      }
      return ranges
    }

    function buildTokens(source, ranges) {
      var tokens = []

      push(tokens, source.slice(0, ranges[0].start), false)

      _.each(ranges, function(range, index) {
        push(tokens, source.slice(range.start, range.end), true)
        var next = ranges[index + 1]
        push(
          tokens,
          source.slice(range.end, next ? next.start : source.length),
          false
        )
      })

      return tokens
    }

    function push(tokens, text, isMatch) {
      if (text) tokens.push({ text: text, isMatch: isMatch })
    }
  }
})()
